import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import useAppCustom from '@hooks/useAppCustom';
import { ItemResponse } from '@models/item';

import DefaultOptions from '../DefaultOptions';
import ExpandedPersonalOptions from '../ExpandedPersonalOptions';
import ItemFooter from '../ItemFooter';
import ItemHeader from '../ItemHeader';
import ItemInfo from '../ItemInfo';
import PersonalOptionButton from '../PersonalOptionButton';
import Recommendation from '../Recommendation';

interface Props {
    item: ItemResponse;
    shopId: string,
}

function ItemContents({ item, shopId }: Props) {
    const { defaultOptionGroups, personalOptionGroups, isSoldOut } = item;
    const { itemOrderButtonPosition } = useAppCustom().item;
    const itemId = item.id;
    return (
        <CtaLayout
            footerPosition={itemOrderButtonPosition}
            footer={<ItemFooter item={item} shopId={shopId} isSoldOut={isSoldOut} />}
            header={<ItemHeader shopId={shopId} itemId={itemId} />} >
            <ItemInfo item={item} shopId={shopId}/>
            <DefaultOptions
                itemId={itemId}
                optionGroups={defaultOptionGroups} />
            <PersonalOptionButton
                itemId={itemId}
                personalOptionGroups={personalOptionGroups} />
            <ExpandedPersonalOptions
                optionGroups={personalOptionGroups}
                itemId={itemId} />
            <Recommendation shopId={shopId} itemId={itemId} />
        </CtaLayout>
    );
}

export default ItemContents;
